<template>
    <div>
        <multiselect class="form-control" v-model="modelo.idciudad" :options="datos" track-by="id" label="nombre" 
        :searchable="true" :close-on-select="true" :show-labels="false" placeholder="Seleccione..."></multiselect>
        <!-- <v-select
          v-model="modelo.idciudad"
          :items="datos"
          chips
          item-text="nombre"
          return-object
          label="Ciudad"
          outlined
          dense
          prepend-icon="mdi-city"
          :rules="rules"
        ></v-select> -->
    </div>
</template>

<script>
import gql from 'graphql-tag'
import {parseJsonError} from '@/components/Utils.js'
export default {
  props: { model: Object, default: { type: Object, required: false, default: null }, rules: { type: Array, required: false, default: () => [] } },
    data(){
        return{
            datos: [],
            modelo: {
                idciudad: null, 
            } 
        }
    },
    watch:{
        'modelo.idciudad': function(){this.model.idciudad=this.modelo.idciudad; },
        'default':function(a){
            if( a == null ) return;
            this.modelo.idciudad = a;
        },
    },
    methods:{
        setNull(){
            this.modelo.idciudad = null;
        },
        async getDatos() {
            var vue = this;
            var sql = gql`query{getCiudades{id,nombre,departamento{nombre,extension}}}`;
            await this.$apollo.query({
            query: sql,
            }).then((data) => {
                var dts = [];
                data.data.getCiudades.forEach( function(e){
                    var de = '';
                    if( e.departamento ) de = e.departamento.nombre;
                    var n = e.nombre+'\t ('+de+')';
                    dts.push( {id:e.id,nombre:n} )
                });
                vue.datos = dts;
                if( this.default != null ) return;
                this.modelo.idciudad = this.default;

            }).catch((error) => {
                window.console.error(error)
                this.$notify( parseJsonError( error,'getCiudades' ) )
            })
        },
    },
    mounted(){
        this.getDatos();
    }
}
</script>